import React, { Component } from 'react';
import { NavLink,Link } from 'react-router-dom'
import './Footer.scss'
import logo from './logo.svg';

import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

class Footer extends Component {

	static propTypes = {
		location: PropTypes.object.isRequired,
	  }
    
    
	render() {
		
		const { location,  } = this.props
        return (
            <footer>
				{!(location.pathname.indexOf("listing") !== -1 ) && <div className="pre-footer">
					<div className="container">
						<div className="image-holder">
							<div className="signup">Apply to be Listed </div>
							<div className="tagline">Are you listed on our private online and book publications?</div>
							<a href="https://online.gpbook.com.au/update/create-choose" className="btn"><i className="fa fa-file-text" />Listing Form</a>
						</div>
					</div>
				</div>}
                <div className="holder">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <img src={require('./logo-text-invert.svg')} alt="GPbook Invert Logo" width="196" />
                                <p>GPbook is the online edition of the Medical & Surgical Specialist Referral Directory by Stephen Hodby which is made for GPs to find the right specialist to refer to. </p>
                                <br />
                                <p>Copyright {new Date().getFullYear()} All Rights Reserved.</p>
                            </div>
                            <div className="col-md-2">
                                <h4>Quick Links</h4>    
                                <ul>
                                    <li>
                                        <NavLink to="/" exact>Home</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/about">About</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/features">Features</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/pricing">Pricing</NavLink>
                                    </li>
                                   
                                    <li>
                                        <NavLink to="/contact">Contact</NavLink>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-2">
                                <h4>About GPbook</h4>
                                <ul>
                                    <li>
                                        <NavLink to="/about/tos" >Terms and Conditions</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/about/specialist-tos">Specialist Terms</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/about/privacy">Privacy Policy</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/about/disclaimer">Disclaimer</NavLink>
                                    </li>
                                   
                                </ul>
                            </div>
                            <div className="col-md-5">
                                <h4>Contact Us Today</h4>
                                <p>You can get in contact with us by
                                 {/*calling <a href="tel:0448 324 286">0448 324 286</a> or  */}
                                 sending an email to <a href="mailto:info@gpbook.com.au">info@gpbook.com.au</a></p>

                                {/* <h5>Social Media:</h5>
                                <p>Connect with us on Social Media</p>
                                <div className="socials">
                                    <span className="fa fa-facebook"></span>
                                    <span className="fa fa-linkedin"></span>
                                    <span className="fa fa-twitter"></span>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyright">
                    Website created by GPbook WA <img src={logo} className="react-logo" alt="logo" /> Copyright {new Date().getFullYear()} All Rights Reserved.
                </div>
               
            </footer>
        );
    }
}

export default withRouter(Footer);


// WEBPACK FOOTER //
// ./src/Components/Layout/Footer.js